/* PawBliss Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile menu toggle
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.header-nav');
  if (mobileBtn && nav) {
    mobileBtn.addEventListener('click', function () {
      const isOpen = nav.classList.toggle('nav-open');
      mobileBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileBtn.textContent = isOpen ? '✕' : '☰';
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('nav-open');
        mobileBtn.setAttribute('aria-expanded', 'false');
        mobileBtn.textContent = '☰';
      });
    });
  }

  // ── Wishlist heart toggle
  document.querySelectorAll('.product-card-wishlist').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.textContent = this.textContent.trim() === '🤍' ? '❤️' : '🤍';
    });
  });

  // ── Category pill filter (collection page)
  document.querySelectorAll('.category-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      document.querySelectorAll('.category-pill').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ── Quantity stepper
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-stepper').querySelector('.qty-input');
      let val = parseInt(input.value, 10) || 1;
      if (this.dataset.dir === 'up')   val = Math.min(val + 1, 99);
      if (this.dataset.dir === 'down') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  // ── Cart count badge (Shopify AJAX)
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function (cart) {
        var counts = document.querySelectorAll('.cart-count');
        counts.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }
  updateCartCount();

  // ── Add to cart handler (for product forms)
  // FIX: previously always read form.dataset.variantId, which is set once at
  // page load and never updates when the shopper changes color/variant or
  // adjusts quantity. Now reads the live "id" and "quantity" fields from the
  // form itself, so the variant/qty actually selected is what gets added.
  document.querySelectorAll('.add-to-cart-form form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn.textContent;
      btn.textContent = '✓ Added!';
      btn.disabled = true;

      var idField = form.querySelector('[name="id"]');
      var variantId = idField ? idField.value : (form.dataset.variantId || 0);
      var qtyField = form.querySelector('[name="quantity"]');
      var quantity = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
      .then(function () {
        updateCartCount();
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
      })
      .catch(function () { btn.textContent = orig; btn.disabled = false; });
    });
  });

  // ── Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // ── Scroll-reveal for product cards
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .featured-card, .testimonial-card').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .4s ease, transform .4s ease';
      io.observe(el);
    });
  }
});
